var map = {
	"./Card/docs/index.mdx": 91472,
	"./ColorContrastInspector/docs/index.mdx": 5325,
	"./Exhibits/docs/index.mdx": 53167,
	"./Figma/docs/index.mdx": 12165,
	"./FontFamilyMatrix/docs/index.mdx": 47867,
	"./Image/docs/index.mdx": 63511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 24453;
module.exports = webpackContext;